// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    This file is necessary because of the styles which come from the global KK style-sheet. After it is migrated styles from this file may be deleted.
*/

body .ag-theme-balham-zeb span {
    color: var(--clr-primary);
}

.ag-react-container{
    width: 100%;
    max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./js/public/static/styles/ag-grid-overrides.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":["/*\n    This file is necessary because of the styles which come from the global KK style-sheet. After it is migrated styles from this file may be deleted.\n*/\n\nbody .ag-theme-balham-zeb span {\n    color: var(--clr-primary);\n}\n\n.ag-react-container{\n    width: 100%;\n    max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
